/*
 * Shared TinyMCE bootstrap (docs/frontend/design-system.md, „Editory TinyMCE").
 *
 * The editing area is an iframe and cannot see the host's custom properties, so --fi-* values
 * are copied into it on init and rewritten on every theme change. Rewriting rather than
 * remove()/re-init is what lets undo history and the caret survive a theme switch.
 */
(function () {
    "use strict";

    // Custom properties read by skins/ui/finest/content.min.css and skins/content/finest.
    var TOKENS = [
        "surface", "surface-2", "surface-3", "text", "text-2", "muted", "line", "line-strong",
        "gold", "gold-deep", "gold-soft", "on-accent", "danger", "danger-soft",
        "success", "success-soft", "warning", "warning-soft",
    ];

    // `paper` editors hold e-mail bodies, which recipients get light — so they are edited light in
    // both app themes. Values mirror $fi-light in www/scss/abstracts/_tokens.scss.
    var PAPER = {
        "surface": "#ffffff",
        "text": "#1c1c1c",
        "text-2": "#666666",
        "muted": "#999999",
        "line": "#e8e8e8",
        "line-strong": "#d4d4d4",
    };

    var paperEditors = typeof WeakSet === "function" ? new WeakSet() : null;

    function isPaper(editor) {
        return paperEditors !== null && paperEditors.has(editor);
    }

    function tokenCss(paper) {
        var host = getComputedStyle(document.documentElement);
        var declarations = TOKENS.map(function (name) {
            var value = paper && PAPER[name] ? PAPER[name] : host.getPropertyValue("--fi-" + name).trim();
            return value ? "--fi-" + name + ":" + value + ";" : "";
        }).join("");
        var scheme = paper ? "light" : (window.finestTheme ? window.finestTheme.get() : "light");

        return ":root{" + declarations + "color-scheme:" + scheme + "}"
            + "body{background-color:var(--fi-surface);color:var(--fi-text)}"
            + "a{color:var(--fi-gold-deep)}";
    }

    function applyTokens(editor) {
        var doc = editor.getDoc();
        if (!doc || !doc.head) return;

        var style = doc.head.querySelector("style[data-fi-tokens]");
        if (!style) {
            style = doc.createElement("style");
            style.setAttribute("data-fi-tokens", "");
            doc.head.appendChild(style);
        }
        style.textContent = tokenCss(isPaper(editor));
    }

    function init(config, options) {
        var paper = !!(options && options.paper);
        var callerSetup = config.setup;
        // The layout's Google Fonts stylesheet, so the editing area uses Inter like the rest of the app.
        var fonts = document.querySelector('link[href*="fonts.googleapis.com/css"]');

        return tinymce.init(Object.assign({
            base_url: "/assets/libs/tinymce/",
            suffix: ".min",
            skin: "finest",
            content_css: fonts ? ["finest", fonts.href] : "finest",
        }, config, {
            setup: function (editor) {
                if (paper && paperEditors !== null) paperEditors.add(editor);
                editor.on("init", function () {
                    applyTokens(editor);
                });
                if (typeof callerSetup === "function") callerSetup.call(this, editor);
            },
        }));
    }

    if (window.finestTheme && typeof window.finestTheme.subscribe === "function") {
        window.finestTheme.subscribe(function () {
            if (!window.tinymce) return;
            tinymce.get().forEach(function (editor) {
                if (editor.initialized) applyTokens(editor);
            });
        });
    }

    window.finestEditor = { init: init };
})();
